import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Currency } from "../../../Reducers/objects/currency";
import { AppState } from "../../../Reducers/Reducers";

export function useUserSelectedSellingCurrency(): Currency | null {
    const user = useSelector((state: AppState) => state.user.user);
    const [refresh, setRefresh] = useState(0);
    const localStorageCurrency = useMemo(() => {
        const localStorageCurrencyData = localStorage.getItem('selectedSellingCurrency');
        return localStorageCurrencyData ? JSON.parse(localStorageCurrencyData) : null;
    }, [refresh]);

    useEffect(() => {
        const handler = () => {
            setRefresh((state) => state + 1);
        }
        document.addEventListener('sellingCurrencyChanged', handler);
        return () => {
            document.removeEventListener('sellingCurrencyChanged', handler);
        }
    }, []);

    return user?.using_currency ?? localStorageCurrency;
}